import React from 'react';
import styles from './HeroSection.module.scss';
import bgImg from '../../images/hero_bg.jpg';
import logo from '../../images/logo.png';

const HeroSection = ({ children }) => {
  const wrapperStyles = [
    styles.wrapper,
  ].join(' ');

  return (
    <section className={wrapperStyles} style={{ backgroundImage: `url(${bgImg})` }}>
      <div className={styles.backdrop} />
      <div className={styles.banner} />
      <div className={styles.logo}>
        <img src={logo} alt="Melting Pot Logo" />
      </div>
    </section>
  );
};

export default HeroSection;